<template>
  <the-navbar :currentView="'services'"></the-navbar>
  <div class="container-div">
    <header>
      <img src="../../../assets/asesoriaMediano.jpeg" class="bg-img" />
      <div class="header">
        <!-- <h1>Asesoría para diseño de procesos educativos</h1> -->
        <h1>Diseño de planes y programas de ciencias de la salud</h1>
        <p>
          Un tipo especial de oferta académica lo constituyen los programas de
          TSU, licenciatura, especialidad, maestría o doctorado en los
          diferentes campos de la salud, nuestro equipo es experto en la
          integración de este tipo de programas y de la carpeta de justificación
          de los criterios esenciales requeridos por la CIFRHS.
        </p>
        <div class="container">
          <div v-for="servicio in servicios" :key="servicio" class="card">
            {{ servicio }}
          </div>
        </div>
      </div>
    </header>
    <p class="credits">
      Imágen empleada: foto de
      <a
        href="https://unsplash.com/@johnschno?utm_source=unsplash&utm_medium=referral&utm_content=creditCopyText"
        class="credit-link"
      >
        John Schnobrich
      </a>
      en
      <a
        href="https://unsplash.com/es/fotos/FlPc9_VocJ4?utm_source=unsplash&utm_medium=referral&utm_content=creditCopyText"
        class="credit-link"
      >
        Unsplash
      </a>
    </p>
  </div>
  <the-footer></the-footer>
</template>

<script>
export default {
  data() {
    return {
      servicios: [
        "Integración de carpeta CIFRHS",
        // "Asesoría en la integración y documentación de procesos escolares y educativos",
        // "Asesoría para la implementación de sistemas de gestión de la calidad en instituciones educativas",
      ],
    };
  },
};
</script>

<style scoped>
header {
  position: relative;
  height: 800px;
  margin-bottom: 25px;
}
.bg-img {
  object-fit: cover;
  /* height: 100%; */
  width: 85%;
  margin-left: 15%;
  clip-path: polygon(
    52% 14%,
    100% 2%,
    100% 43%,
    100% 78%,
    68% 100%,
    39% 82%,
    6% 78%,
    0% 43%,
    12% 8%
  );
}
.header {
  border-radius: 12px;
  /* box-shadow: 0 2px 8px rgba(0, 0, 0, 0.26); */
  padding: 2rem;
  margin: 2rem auto;
  max-width: 65%;
  background-color: #e7f1f8;
  position: absolute;
  top: 27px;
  left: 60px;
  opacity: 95%;
  border-radius: 0 0 25% 0;
}

.container {
  display: flex;
  width: 80%;
  gap: 20px;
  margin: auto;
}
.card {
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.26);
  padding: 1rem;
  margin: 2rem auto;
  background-color: #a0bfdf;
  width: 450px;
  display: flex;
  align-items: center;
  justify-items: center;
}

.credits {
  font-size: 10px;
  text-align: left;
  margin: 0px;
}

.credit-link {
  color: #2d353d;
  margin: 0;
}

@media (max-width: 768px) {
  header {
    position: static;
    height: auto;
  }
  .header {
    max-width: 95%;
    margin: 10px;
    padding: 10px;
    position: static;
    opacity: 100%;
    border-radius: 0;
  }
  .container {
    flex-wrap: wrap;
    gap: 10px;
    width: 100%;
    margin: 0;
    padding: 0;
  }
  .card {
    margin: 10px;
    width: 100%;
  }
}
</style>
